export default __webpack_public_path__ + "static/media/Info Icon.8ff35b09.png";